<template>
  <div class="selection-box" :class="getValidationClasses(`selection-box--${type}`)">
    <div class="selection-box__label" v-html="label" />
    <div class="selection-box__body">
      <select :value="value" @input="$emit('input', $event.target.value)">
        <option v-for="option in options" :key="option.value" :value="option.value">
          {{ option.text }}
        </option>
      </select>
      <Icon v-if="icon" class="selection-box__icon" :icon="icon" />
    </div>

    <div v-if="errors.has(validationField(validateAs))" class="v-field-error">{{ errors.first(validationField(validateAs)) }}</div>
  </div>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

import CustomControlValidationMixin from '@/components/CustomControlValidationMixin'
import Icon from '@/components/Icon.vue'

@Component({
  mixins: [
    CustomControlValidationMixin,
  ],
  components: {
    Icon,
  },
  props: {
    value: {
      // String or Number
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: () => '&nbsp;',
    },
    options: {
      type: Array,
      required: false,
      default: () => [],
    },
    type: {
      type: String,
      required: false,
      default: () => 'mobile',
    },
    icon: {
      type: String,
      required: false,
      default: () => 'v',
    },
    validateAs: {
      type: String,
      required: false,
    },
  },
})
export default class SelectBox extends Vue {
}
</script>

<style lang="scss">
@import '../forms/FormValidationIndicator.scss';

.selection-box {
  @include form-validation-indicator(21px, 30px);
  position: relative;

  &--blue-border {
    background-image: url('/assets/images/input-box-underline-blue.png');
    background-position-x: right;
    background-position-y: bottom;
    background-repeat: no-repeat;
    user-select: none;

    select {
      border: none;
    }
  }

  &__body {
    display: grid;
    grid-template-columns: 1fr 28px;
  }

  &__label {
    font-size: 10px;
  }

  &__icon {
    margin: 7px 0px 0px 8px;
    font-size: 7px;
    color: inherit;
  }

  &--mobile {
    select {
      width: 100%;
      padding: 5px 0;
    }
  }

  &--desktop select {
    width: 100%;
    text-transform: none;
    font-size: inherit;
    color: inherit;
    font-weight: inherit;
  }

  &.field-invalid &__body {
    border-bottom: 1px solid #E71F6C;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/search/SelectBox.vue